import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { TiTick } from "react-icons/ti";
import PropTypes from 'prop-types';
import Loader from "../../../utils/Loader";

const RestSettings = (props) => {
    const { refreshLogo } = props;
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const token = localStorage.getItem("token");
    const { rest_slug2 } = useParams();
    const [userName, setUserName] = useState("");
    const [surName, setSurName] = useState("");
    const [email, setEmail] = useState("");
    const [mobilePhone, setMobilePhone] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [profileSettingsData, setProfileSettingsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getRestProfileData = useCallback(async () => {
        try {
            const responseProfileData = await axios.get(`${apiUrl}/api/v1/restaurants/${rest_slug2}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setProfileSettingsData(responseProfileData.data);
        } catch (error) {
            console.error('Error fetching Profile Settings data:', error);
        }
    }, [apiUrl, rest_slug2, token, setProfileSettingsData]);

    const handleSave = async () => {
        const formData = new FormData();
        formData.append('restaurant_id', rest_slug2);
        formData.append('username', userName);
        formData.append('surname', surName);
        formData.append('email', email);
        formData.append('mobile_phone', mobilePhone);
        formData.append('company_name', companyName);

        try {
            setIsLoading(true);
            const response = await axios.post(`${apiUrl}/api/v1/restaurant-profile`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = response.data;
            refreshLogo();
            toast.success(data?.message, { theme: "colored", autoClose: 1000 });
        } catch (error) {
            console.error('Error saving restaurant Information:', error);
            const errors = error?.response?.data?.errors;
            if (errors) {
                for (const key in errors) {
                    if (Array.isArray(errors[key])) {
                        errors[key].forEach((message) => {
                            toast.error(message, {
                                theme: 'colored',
                                autoClose: 3000,
                            });
                        });
                    }
                }
            } else {
                toast.error(error?.response?.data?.message, {
                    theme: "colored",
                    autoClose: 3000,
                });
            }
        } finally {
            setIsLoading(false);
        }

    };

    useEffect(() => {
        getRestProfileData();
    }, [getRestProfileData]);

    useEffect(() => {
        if (profileSettingsData) {
            setUserName(profileSettingsData?.username || "");
            setSurName(profileSettingsData?.surname || "");
            setEmail(profileSettingsData?.email || "");
            setMobilePhone(profileSettingsData?.mobile_phone || "");
            setCompanyName(profileSettingsData?.company_name || "");
        }
    }, [profileSettingsData]);

    return (
        <>
            <section className="border-t border-[#D9D9D9] md:mt-5 md:pt-10 pt-5">
                <h3 className="md:ext-2xl text-2xl font-bold mb-5 poppins-medium">Impostazioni del profilo</h3>
                <div className="w-full h-auto bg-[#FCFCFC] text-left text-red-700 space-y-5 border-[2px] border-[#8B24332B] sm:p-7 lg:p-10 p-5 rounded-xl shadow-md font-sans ">
                    <div className="flex flex-col space-y-3 lg:space-y-4 mb-4">
                        <div className="shadow-md space-y-3 mt-2 lg:mt-5 px-5 py-8 border rounded-lg">
                            <div className="flex md:flex-row flex-wrap lg:flex-nowrap flex-col gap-6">
                                <div className="flex flex-col w-full md:w-[100%] lg:w-[50%]  space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Nome:
                                    </label>
                                    <input
                                        type="text"
                                        className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={userName || ""}
                                        onChange={(e) => setUserName(e.target.value)}
                                    />
                                </div>
                                <div className="flex flex-col w-full md:w-[100%] lg:w-[50%]  space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Cognome:
                                    </label>
                                    <input
                                        type="text"
                                        className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={surName || ""}
                                        onChange={(e) => setSurName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="flex md:flex-row flex-wrap lg:flex-nowrap flex-col gap-6">
                                <div className="flex flex-col w-full md:w-[100%] lg:w-[50%]  space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Email:
                                    </label>
                                    <input
                                        type="email"
                                        className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={email || ""}
                                        onChange={(e) => setEmail(e.target.value)}
                                        disabled
                                        style={{ cursor: "not-allowed" }}
                                    />
                                </div>
                                <div className="flex flex-col w-full md:w-[100%] lg:w-[50%]  space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Cellulare:
                                    </label>
                                    <input
                                        type="number"
                                        className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={mobilePhone || ""}
                                        onChange={(e) => setMobilePhone(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="flex md:flex-row flex-wrap lg:flex-nowrap flex-col gap-6">
                                <div className="flex flex-col w-full md:w-[100%] lg:w-[calc(50%-14px)]  space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Ragione Sociale:
                                    </label>
                                    <input
                                        type="text"
                                        className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={companyName || ""}
                                        onChange={(e) => setCompanyName(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex text-sm sm:flex-row flex-col justify-start gap-4 mt-10">
                        {isLoading ? (
                            <button disabled type="button"
                                className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group">
                                <Loader />
                                Loading...
                            </button>
                        ) : (
                            <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                                onClick={handleSave}
                            >
                                <TiTick size={"25px"} color="green" />
                                <span className="poppins-regular">Aggiorna</span>
                            </button>
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}
RestSettings.propTypes = {
    refreshLogo: PropTypes.func.isRequired,
};

export default RestSettings;